import { render } from "./SendTrait.vue?vue&type=template&id=c09d3330"
import script from "./SendTrait.vue?vue&type=script&lang=js"
export * from "./SendTrait.vue?vue&type=script&lang=js"

import "./SendTrait.vue?vue&type=style&index=0&id=c09d3330&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__